<template>
  <div class="p-2 rounded-lg bg-white">
    <div v-if="user">
      <div v-if="user.lenders.length > 0">
        <div>
          <h3 class="text-lg leading-6 font-medium text-indigo-700">
            Lender Information - Agent Information
          </h3>
          <p class="mt-1 text-sm text-gray-500">
            Use a permanent address where you can receive mail
          </p>
        </div>

        <div
          :class="styleGrid ? 'lg:grid-cols-1' : 'lg:grid-cols-2'"
          class="mt-6 grid gap-16  lg:gap-x-5 lg:gap-y-12 pb-4 "
        >
          <div class="bg-gray-50 rounded-md p-2">
            <span
              @click="removeLender(user)"
              class="text-red-500 hover:text-red-600 relative cursor-pointer float-right"
            >
              <i class="far fa-trash-alt"></i
            ></span>

            <span
              @click="
                displayModal(user.lenders, 'lender', user.profile.loan_file)
              "
              class="text-gray-400 hover:text-gray-600 relative cursor-pointer float-right"
            >
              <i class="fas fa-edit"></i
            ></span>

            <p class="sm:col-span-6 text-sm text-gray-500">
              <time datetime="2020-03-16">{{
                formatDate(user.lenders[0].created_at)
              }}</time>
            </p>

            <span class="flex text-pink-600">
              <i class="far fa-file-pdf"></i>
              <b
                @click="displayModal(user.profile.loan_file, 'pdf')"
                class="cursor-pointer ml-2 text-sm"
              >
                Preview
              </b>
            </span>

            <a class="mt-2 block">
              <p class="text-xl font-semibold text-gray-900">
                {{ user.lenders[0].name }}
              </p>
              <p class="mt-3 text-base text-gray-500">
                {{ user.lenders[0].phone }}
              </p>
            </a>
            <div class="mt-3">
              <a
                :href="user.lenders[0].website"
                class="text-base font-semibold text-indigo-600 hover:text-indigo-500"
              >
                Website
              </a>
            </div>
          </div>

          <div
            v-if="user.lender_agent.length > 0"
            class="bg-gray-50 rounded-md p-2"
          >
            <span
              @click="displayModal(user.lender_agent, 'agent')"
              class="text-gray-400 hover:text-gray-600 relative cursor-pointer float-right"
            >
              <i class="fas fa-edit"></i
            ></span>

            <p class="sm:col-span-6 text-sm text-gray-500">
              <time datetime="2020-03-16">{{
                formatDate(user.lender_agent[0].created_at)
              }}</time>
            </p>
            <a class="mt-2 block">
              <p class="text-xl font-semibold text-gray-900">
                {{ user.lender_agent[0].name }}
              </p>
              <p class="mt-3 text-base text-gray-500">
                {{ user.lender_agent[0].phone }}
              </p>
            </a>
            <div class="mt-3">
              <a
                class="text-base font-semibold text-indigo-600 hover:text-indigo-500"
              >
                {{ user.lender_agent[0].email }}
              </a>
            </div>
          </div>

          <div v-else>
            <div class="relative">
              <div
                class="absolute inset-0 flex items-center"
                aria-hidden="true"
              >
                <div class="w-full border-t border-gray-300"></div>
              </div>
              <div class="relative flex justify-center">
                <button
                  @click="addLenderAgent = !addLenderAgent"
                  type="button"
                  class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <!-- Heroicon name: solid/plus-sm -->
                  <svg
                    class="-ml-1.5 mr-1 h-5 w-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span>Add Lender Agent</span>
                </button>
              </div>
            </div>

            <v-fade-transition v-if="addLenderAgent" mode="out-in">
              <div>
                <div
                  class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                >
                  <div class="sm:col-span-6">
                    <label
                      for="first-name"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Name
                    </label>
                    <div class="mt-1">
                      <input
                        type="text"
                        v-model="lenderAgent.name"
                        class="shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                  </div>

                  <div class="sm:col-span-3">
                    <label
                      for="first-name"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Phone
                    </label>
                    <div class="mt-1">
                      <input
                        type="text"
                        v-model="lenderAgent.phone"
                        class="shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                  </div>

                  <div class="sm:col-span-3">
                    <label
                      for="email"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Email address
                    </label>
                    <div class="mt-1">
                      <input
                        type="email"
                        autocomplete="email"
                        v-model="lenderAgent.email"
                        class="p-1 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                </div>

                <button
                  :disabled="
                    lenderAgent.name == '' ||
                      lenderAgent.phone == '' ||
                      lenderAgent.email == ''
                  "
                  @click.prevent="saveAgent()"
                  type="submit"
                  class="disabled:opacity-50 mt-2 inline-flex justify-center py-1 px-3 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-green-600 hover:bg-green-700 focus:outline-none"
                >
                  Save
                </button>
              </div>
            </v-fade-transition>
          </div>
        </div>
      </div>

      <div v-else class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
        <div class="sm:col-span-6">
          <h3 class="text-lg leading-6 font-medium text-indigo-700">
            Lender Information
          </h3>
          <p class="mt-1 text-sm text-gray-500">
            Use a permanent address where you can receive mail
          </p>
        </div>

        <div class="sm:col-span-3">
          <label
            for="first-name"
            class="block text-sm font-medium text-gray-700"
          >
            Name
          </label>
          <div class="mt-1">
            <input
              type="text"
              v-model="lender.name"
              class="shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
          </div>
        </div>

        <div class="sm:col-span-3">
          <label
            for="first-name"
            class="block text-sm font-medium text-gray-700"
          >
            Phone
          </label>
          <div class="mt-1">
            <input
              type="text"
              v-model="lender.phone"
              class="shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
          </div>
        </div>

        <div class="sm:col-span-3">
          <label for="email" class="block text-sm font-medium text-gray-700">
            Website
          </label>
          <div class="mt-1">
            <input
              type="email"
              autocomplete="email"
              v-model="lender.website"
              class="p-1 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
          </div>
        </div>

        <div class="sm:col-span-3">
          <label for="photo" class="block text-sm font-medium text-gray-700">
            Pre-Approval
          </label>
          <div class="mt-1 flex items-center">
            <span class="h-12 w-12 rounded-full overflow-hidden bg-gray-200">
              <svg
                class="h-full w-full text-gray-600"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 48 48"
                aria-hidden="true"
              >
                <path
                  d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>

            <div class="text-xs ml-2 text-gray-600">
              <div class="relative flex text-green-500" v-if="imageUrl">
                <button
                  @click="openModal"
                  type="button"
                  class="inline-flex items-center px-2 py-1 text-xs font-base rounded-full shadow-sm text-green-600 bg-green-50 hover:text-green-700 focus:outline-none"
                >
                  <b class="mr-1">Preview:</b>
                  <span v-if="fileName.length <= 25"> {{ fileName }} </span>
                  <span v-else> {{ fileName | shortText(25) }}... </span>
                </button>
                <button
                  @click="clearFile"
                  type="button"
                  class="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full shadow-sm text-red-600 bg-red-50  hover:text-red-700 focus:outline-none"
                >
                  Remove
                </button>
              </div>
              <label
                v-else
                for="file-upload"
                class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
              >
                <span>Upload a file</span>
                <input
                  @change="uploadApproval"
                  id="file-upload"
                  name="file-upload"
                  type="file"
                  accept="application/pdf,image/png,image/jpeg"
                  class="sr-only"
                />
              </label>

              <div v-if="modalDisplay">
                <edit-modal
                  @hideModal="closeModal"
                  :filePath="imageUrl"
                  type="pdf"
                  :isDisplay="true"
                ></edit-modal>
              </div>
            </div>
          </div>
        </div>

        <div class="sm:col-span-6 sm:-mt-8">
          <button
            :disabled="
              lender.name == '' || lender.phone == '' || preApproval == ''
            "
            v-if="!proccessing"
            @click.prevent="submitLender()"
            type="submit"
            class="disabled:opacity-50 py-1 px-3 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-green-600 hover:bg-green-700 focus:outline-none"
          >
            Save
          </button>
          <span
            v-else
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
          >
            Processing...
          </span>
        </div>
      </div>

      <div v-if="showModal">
        <edit-modal
          @hideModal="closeModal"
          :selected="selected"
          :type="type"
          :pdfFile="pdfFile"
        ></edit-modal>
      </div>
    </div>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
import Swal from "sweetalert2";
import moment from "moment";
export default {
  props: ["user", "docId", "styleGrid"],
  data() {
    return {
      addLenderAgent: false,
      preApproval: "",
      showModal: false,
      modalDisplay: false,
      selected: "",
      pdfFile: "",
      type: "",

      imageUrl: "",
      proccessing: false,
      fileName: "",
      lender: {
        name: "",
        website: "",
        phone: ""
      },
      lenderAgent: {
        name: "",
        email: "",
        phone: ""
      }
    };
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  methods: {
    openModal() {
      this.modalDisplay = true;
    },

    clearFile() {
      this.imageUrl = "";
      this.preApproval = "";
    },

    uploadApproval(e) {
      this.preApproval = e.target.files || e.dataTransfer.files;
      this.fileName = e.target.files[0].name;
      const file = e.target.files[0];
      this.imageUrl = URL.createObjectURL(file);
    },

    formatDate(date) {
      let newDate = moment.utc(date).format("LL");
      return (this.dataModal = newDate);
    },

    displayModal(agent, type, pdf = null) {
      this.showModal = true;
      this.selected = agent;
      this.pdfFile = pdf;
      this.type = type;
    },

    saveAgent() {
      window.axios.post("/api/saveLenderAgent", this.lenderAgent).then(() => {
        this.lenderAgent = {};
        this.$store.dispatch("getUser");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Lender Agent successfully added",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    submitLender() {
      this.proccessing = true;
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

      let pdfDoc = new FormData();

      $.each(this.preApproval, function(key, image) {
        pdfDoc.append(`image[${key}]`, image);
      });

      pdfDoc.append("name", this.lender.name);
      pdfDoc.append("website", this.lender.website);
      pdfDoc.append("phone", this.lender.phone);

      if (this.docId) {
        pdfDoc.append("submissionId", this.docId.id);
      }

      window.axios.post("/api/saveLender", pdfDoc, config).then(() => {
        this.proccessing = false;
        this.clearFile();
        this.lender = {};
        this.$store.dispatch("getUser");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Lender successfully saved",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    removeLender(user) {
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          window.axios.post("/api/removeLender/" + user.id).then(() => {
            this.$store.dispatch("getUser");
            Swal.fire("Deleted!", "Your Lender has been deleted.", "success");
          });
        }
      });
    },

    closeModal() {
      this.showModal = false;
      this.selected = "";
      this.type = "";
      this.modalDisplay = false;
    }
  }
};
</script>
